import React, { useEffect, useState } from "react";
import { Users } from "lucide-react";
import api from "../../lib/api";
import { Card } from "../ui/card";

// "last seen 25 min ago" / "last seen yesterday 6:40 PM"
function lastSeenText(iso) {
  if (!iso) return "no activity yet";
  const then = new Date(iso);
  const mins = Math.floor((Date.now() - then.getTime()) / 60000);
  if (mins < 60) return `last seen ${Math.max(1, mins)} min ago`;
  const time = then.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const thenDay = new Date(then); thenDay.setHours(0, 0, 0, 0);
  const dayDiff = Math.round((today - thenDay) / 86400000);
  if (dayDiff === 0) return `last seen today ${time}`;
  if (dayDiff === 1) return `last seen yesterday ${time}`;
  return `last seen ${then.toLocaleDateString(undefined, { day: "numeric", month: "short" })} ${time}`;
}

export default function TeamRightNow() {
  const [data, setData] = useState(null);
  useEffect(() => {
    const load = () => api.get("/activity/presence").then((r) => setData(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);

  if (!data) return null;
  return (
    <Card className="p-4 h-full" data-testid="team-right-now">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div>
          <h3 className="font-heading font-semibold text-base flex items-center gap-2">
            <Users className="w-4 h-4 text-primary" />Team Right Now
          </h3>
          <p className="text-[11px] text-muted-foreground">Who has the CRM open at this moment</p>
        </div>
        <span data-testid="online-count" className="text-[11px] font-semibold bg-secondary px-2 py-0.5 rounded-full">
          {data.online_count} of {data.total} online
        </span>
      </div>
      <div className="mt-2 divide-y divide-border">
        {data.rows.length === 0 && (
          <div className="text-xs italic text-muted-foreground py-2">No active sales staff accounts yet.</div>
        )}
        {data.rows.map((r) => (
          <div key={r.user_id} data-testid={`presence-${r.user_id}`}
            className="flex items-center justify-between gap-3 py-1.5">
            <div className="min-w-0">
              <div className="text-sm font-medium truncate leading-tight">{r.name}</div>
              {!r.online && (
                <div className="text-[10px] text-muted-foreground">{lastSeenText(r.last_seen)}</div>
              )}
              {r.online && r.hours_today > 0 && (
                <div className="text-[10px] text-muted-foreground">{r.hours_today} h in the CRM today</div>
              )}
            </div>
            <span className="flex items-center gap-1.5 shrink-0">
              <span className={`w-2 h-2 rounded-full ${r.online ? "bg-emerald-500" : "bg-red-500"}`} />
              <span className={`text-[11px] font-semibold ${r.online ? "text-emerald-700" : "text-red-600"}`}
                data-testid={`presence-status-${r.user_id}`}>
                {r.online ? "Online" : "Offline"}
              </span>
            </span>
          </div>
        ))}
      </div>
    </Card>
  );
}
